/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
}) {
  return questionnaire.map(question => {
      if (question.idQuestion === 2199) {
        const updatedQuestion = {
          ...question,
          childrenQuestions: question.childrenQuestions.map((childQuestion) => {
            if (childQuestion.idQuestion == 2205 || childQuestion.idQuestion == 2206) {
              return {
                ...childQuestion,
                disabled: true
              }
            }
            return childQuestion;
          })
        }
        return updatedQuestion
      }
      return question;
    })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  updatedObligorGroup,
  setEmailContentGroup,
}) {
  try {
  } catch (e) {
    console.log('OBLIGOR_PERC - handleQuestionChange - error', e)
  }
};


const events = {
  handleInitialAdjustments,
  handleQuestionChange,
};

export { events };